import { AppShell, Text } from '@mantine/core';

export default function NavImpersonating() {
  return (
    <AppShell.Header
      px={{ sm: 'sm', md: 'md', lg: 'xl' }}
      bg="var(--content-active)"
      display="flex"
      style={{
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Text variant="caption-xs" c="var(--content-accent-secondary)">
        Corpa
      </Text>
      <Text variant="sublabel-sm" c="var(--content-accent-secondary)">
        This site is live
      </Text>
    </AppShell.Header>
  );
}
